<template>
  <div class="usermanagetable">
    <el-table :data="tableData" style="width: 100%;padding:10px 10px 0 10px;"  border>
      <el-table-column prop="name" label="姓名">
        <template slot-scope="scope">
          <el-tooltip class="item" effect="dark" :content="scope.row.desc || '暂无备注'" placement="top">
            <span>{{scope.row.name}}</span>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column prop="mobile" label="手机"></el-table-column>
      <el-table-column prop="email" label="邮箱"></el-table-column>
      <el-table-column prop="userType" label="类型">
        <template slot-scope="scope">
          <span v-if="scope.row.id === 60000">超级管理员</span>
          <span v-if="scope.row.id !== 60000">{{scope.row.userType === 0 ? '内部用户' : '外部用户'}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="status" label="状态" width="70">
        <template slot-scope="scope">
          <div v-if="scope.row.status === 1">
            <el-tag type="success">{{'开启'}}</el-tag>
          </div>

          <div v-if="scope.row.status === 0">
            <el-tag type="danger">{{'停用'}}</el-tag>
          </div>

          <div v-if="scope.row.status !== 0 && scope.row.status !== 1">
            <el-tag type="info">{{'无'}}</el-tag>
          </div>
          <!-- <span
            :style="{'color':scope.row.status === 1 ? 'red' : '#606266'}"
          >{{scope.row.status === 0 ? '开启' : '停用'}}</span> -->
        </template>
      </el-table-column>
      <!-- <el-table-column prop="roleIds" label="角色"></el-table-column> -->
      <el-table-column prop="roleNames" label="角色"></el-table-column>
      <el-table-column label="操作" width="300">
        <template slot-scope="scope">
          <el-button @click="changeClick(scope)" v-if="scope.row.id !== 60000" style="color:#185ED3;font-weight:bold;font-size:13px;" type="text" class="btn" size="small"><i style="margin-right:3px;" class="el-icon-edit-outline"></i>修改</el-button>
          <span style="margin:0 11px;" v-if="scope.row.id !== 60000">|</span>
          <!-- <el-button
            @click="closeClick(scope)"
            type="text"
            class="btn"
            size="small"
          >{{scope.row.status === 1 ? '开启' : '停用'}}</el-button> -->
          <el-button @click="closeClick(scope)" v-if="scope.row.status === 1" style="color:#F96900;font-weight:bold;font-size:13px;" type="text" class="btn" size="small"><i style="margin-right:3px;" class="el-icon-circle-close"></i>停用</el-button>
          <el-button @click="closeClick(scope)" v-if="scope.row.status !== 1" style="color:#13aa65;font-weight:bold;font-size:13px;" type="text" class="btn" size="small"><i style="margin-right:3px;" class="el-icon-document-checked"></i>开启</el-button>
          <span style="margin:0 11px;" v-if="scope.row.id !== 60000 && false">|</span>
          <el-button @click="removeClick(scope)" v-if="scope.row.id !== 60000 && false" style="color:#FF4545;font-weight:bold;font-size:13px;" type="text" class="btn" size="small"><i style="margin-right:3px;" class="el-icon-delete"></i>删除</el-button>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
// import {userTabletype,userTablemode} from '@/constants/tablecommon'
import { listAuthRole } from "@/api/authRole";
export default {
  name: "usermanagetable",
  props: {
    tableData: Array
  },
  data() {
    return {
      // userTabletype,
      // userTablemode,
      // tableData:[
      //   {
      //     name:'王思',
      //     phone:'18061663600',
      //     email:'zjy199610@126.com',
      //     type:userTabletype[1],
      //     mode:userTablemode[2],
      //     role:'记者'
      //   },
      //   {
      //     name:'王思',
      //     phone:'18061663600',
      //     email:'zjy199610@126.com',
      //     type:userTabletype[1],
      //     mode:userTablemode[2],
      //     role:'记者'
      //   },{
      //     name:'王思',
      //     phone:'18061663600',
      //     email:'zjy199610@126.com',
      //     type:userTabletype[2],
      //     mode:userTablemode[1],
      //     role:'记者'
      //   },
      // ]
    };
  },
  methods: {
    changeClick(scope) {
      this.$emit("changeClick", scope);
    },
    removeClick(scope) {
      this.$emit("removeClick", scope);
    },
    closeClick(scope) {
      this.$emit("closeClick", scope);
    },

  },
  created() {
    // this.listAuthRoleAsync()
    
  },
  mounted(){
    // console.log(this.tableData)
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.table {
  width: auto;
}
.active {
  color: red;
}
.btn:hover{
  text-decoration: underline;
}
</style>
